
  var _styles = {
  "city-selection-header-wrap": {
    "height": "2.74667rem",
    "overflow": "hidden"
  },
  "city-selection-header-image": {
    "display": "flex",
    "alignItems": "center"
  },
  "city-selection-header-title-image": {
    "marginTop": "0.46667rem"
  },
  "header-tips": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "lineHeight": "0.48rem",
    "textAlign": "center",
    "zIndex": 1,
    "marginTop": "0.13333rem"
  },
  "city-selection-header-append-block": {
    "width": "100%",
    "height": "0.53333rem",
    "borderTopLeftRadius": "0.26667rem",
    "borderTopRightRadius": "0.26667rem",
    "backgroundColor": "rgb(255,255,255)",
    "marginTop": "0.37333rem"
  },
  "city-selection-main": {
    "paddingTop": 0,
    "paddingRight": "0.26667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.26667rem",
    "position": "relative",
    "top": "-0.01333rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "city-selection-input-wrap": {
    "backgroundColor": "rgb(244,245,248)",
    "height": "0.85333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "borderRadius": "0.58667rem",
    "paddingRight": "0.53333rem"
  },
  "city-selection-input-icon": {
    "marginLeft": "0.32rem",
    "width": "0.48rem",
    "height": "0.48rem"
  },
  "city-selection-input": {
    "width": "100%",
    "marginLeft": "0.13333rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(0,0,0)",
    "lineHeight": "0.53333rem",
    "height": "0.53333rem",
    "paddingLeft": "0.06667rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "city-selection-container": {
    "padding": "0.26667rem"
  },
  "city-selection-item-text": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.53333rem",
    "margin": "0.24rem"
  },
  "city-selection-not-found": {
    "display": "flex",
    "alignItems": "center"
  },
  "city-selection-not-found-image": {
    "marginTop": "0.66667rem",
    "height": "0.4rem",
    "width": "0.4rem"
  },
  "city-selection-not-found-text-container": {
    "flexDirection": "row",
    "justifyContent": "center",
    "marginTop": "0.64rem"
  },
  "city-selection-not-found-text-normal": {
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.37333rem",
    "marginTop": "0.26667rem"
  }
};



  module.exports = _styles;
  